module.exports = __webpack_public_path__ + "media/images/badge-sale-b20beae007b967a63a1063407b697c69.svg";